import { Component } from 'react';
import { GroupControl } from '../../../../GroupField';
import DistanceField from '../Field';
import DistanceControl from '../Control';

export default class MakeGroupField extends Component {
  render() {
    return (
      <DistanceField
        {...this.props}
        component={GroupControl}
        FormControl={DistanceControl}
      />
    );
  }
}
